import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Button } from '@mui/material';
import { SwapHoriz } from '@mui/icons-material';
import { teacherModuleAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function StudentHandoverButton({ studentId, batchId, sx }) {
  const navigate = useNavigate();
  const { hasRole } = useAuth();
  const canView = hasRole(['teacher', 'teacher_supervisor', 'teacher_admin']);

  const availabilityQuery = useQuery(
    ['teachingHandoverAvailability', studentId, batchId],
    async () => {
      const res = await teacherModuleAPI.getTeachingHandoverAvailability(studentId, { batchId });
      return res.data?.data?.available === true;
    },
    {
      enabled: canView && !!studentId && !!batchId,
      staleTime: 5 * 60 * 1000,
      retry: false,
    }
  );

  if (!canView || !availabilityQuery.data) return null;

  return (
    <Button
      size="small"
      variant="contained"
      color="secondary"
      startIcon={<SwapHoriz sx={{ fontSize: 16 }} />}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        const qs = batchId ? `?batchId=${encodeURIComponent(batchId)}` : '';
        navigate(`/teacher/students/${studentId}/teaching-handover${qs}`);
      }}
      sx={{
        textTransform: 'none',
        fontWeight: 800,
        minWidth: 0,
        py: 0.25,
        px: 1,
        flexShrink: 0,
        ...sx,
      }}
    >
      Handover
    </Button>
  );
}
